import React, { useState } from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import styles from './CollectionDetailHeader.module.scss';
import { formatDate } from '../../../../lib/utils';
import actions from './actions';
import Button from '../../../Button';

export function CollectionDetailHeader(props) {
  const [isCollectionSaveable, setIsCollectionSaveable] = useState(true)

  const setNewTitle = (e) => {
    setIsCollectionSaveable(e.target.value.trim())
    props.setNewCollectionTitle(e.target.value);
  };

  const saveEdit = (newName) => {
    return (e) => {
      props.saveEdit(props.collection.uuid, newName);
    };
  };

  const checkEnterSubmit = (newName) => (e) => {
    if (e.charCode === 13) {
      props.saveEdit(props.collection.uuid, newName);
    }
  };

  return (
    <div className={styles.header}>
      {props.isEditingCollection ? (
        <>
          <input
            className={styles.titleInput}
            disabled={props.savingCollection}
            onChange={setNewTitle}
            onKeyPress={checkEnterSubmit(props.newCollectionName)}
            placeholder='Title'
            type='text'
            value={props.newCollectionName}
          />
          <div className={styles.editActions}>
            <Button
              disabled={props.savingCollection || !isCollectionSaveable}
              onClick={saveEdit(props.newCollectionName)}
              size={Button.SIZE.tiny}
            >
              Save
            </Button>
            <Button
              disabled={props.savingCollection}
              onClick={props.cancelEdit}
              size={Button.SIZE.tiny}
              theme={Button.THEME.whiteOutline}
            >
              Cancel
            </Button>
          </div>
        </>
      ) : (
        <div className={styles.title}>
          <h1>{props.collection.title}</h1>
        </div>
      )}
      <p className={styles.createdDate}>
        {formatDate(props.collection.createdAt)}
      </p>
    </div>
  );
}

CollectionDetailHeader.propTypes = {
  collection: PropTypes.object,
  isEditingCollection: PropTypes.bool,
  newCollectionName: PropTypes.string,
  savingCollection: PropTypes.bool,
  //actions
  setNewCollectionTitle: PropTypes.func,
  saveEdit: PropTypes.func,
  cancelEdit: PropTypes.func,
};

export default connect(
  (model) => ({
    collection: model.collections.selectedCollection,
    isEditingCollection: model.collections.isEditingCollection,
    newCollectionName: model.collections.newCollectionName,
    savingCollection: model.collections.savingCollection,
  }),
  actions
)(CollectionDetailHeader);
